import { Container } from '@/components/ui/container'
import { useSettingData } from '@/providers/setting-provider'
import Link from 'next/link'

export function TopBarPromotion({
  isScrollingDown,
}: {
  isScrollingDown: boolean
}) {
  const homeSetting = useSettingData()

  if (homeSetting?.topbar?.hide || !homeSetting?.topbar?.heading) {
    return null
  }

  return (
    <div
      aria-hidden={isScrollingDown}
      className='h-[34px] overflow-hidden bg-neutral-600 text-light'
      style={{
        display: isScrollingDown ? 'none' : 'block',
        transform: isScrollingDown ? 'translateY(-100%)' : 'translateY(0)',
        transition: 'transform 0.3s ease-out, opacity 0.3s ease-out',
      }}
      data-tracking-level-2={'Topbar_Promotion'}
    >
      <Container size='full' className='py-2'>
        <div className='flex items-center justify-center whitespace-nowrap text-xs font-medium uppercase max-lg:animate-marquee2 lg:text-sm lg:leading-4.5'>
          {homeSetting?.topbar?.heading}
          <Link
            href={homeSetting?.topbar?.link ?? '/'}
            aria-label={homeSetting?.topbar?.cta_text}
            className='ml-4 leading-4.5 underline underline-offset-1'
          >
            {homeSetting?.topbar?.cta_text}
          </Link>
        </div>
      </Container>
    </div>
  )
}
